import React, { ReactElement } from "react";
import { Instance } from "mobx-state-tree";
import {
  CornerRadius,
  FoundationColorTokens,
  Shadow,
  Spacing,
  Typography,
} from "@surya-digital/leo-reactjs-material-ui";
import { TFunction } from "i18next";
import { BorderStyle } from "@pulse/shared-components";
import { SurveyQuestionViewStoreNames } from "../stores/SurveyViewDetailsStore";
import { QuestionView } from "./QuestionView";
import { QuestionTypeGraphs } from "./ChartSelection";
import { observer } from "mobx-react";
import { RankingQuestionViewModelV1 } from "../models/RankingQuestionViewModelV1";
import { DataPropsForRanking } from "./DataSection";
import { getButtonProps, UpdateQuestionViewParams } from "./QuestionViews";
import { SignInStore } from "../../auth/store/SignInStore";

interface RankingQuestionViewProps {
  surveyQuestionView: Instance<typeof RankingQuestionViewModelV1>;
  typography: Typography;
  t: TFunction;
  tokens: FoundationColorTokens<string>;
  spacing: Spacing;
  border: BorderStyle;
  cornerRadius: CornerRadius;
  boxShadow: Shadow;
  updateQuestionViewParams?: UpdateQuestionViewParams;
  isSurveyViewOptionDisplayTextSelected: boolean;
  allowSPoCToSelectGraphType: boolean;
  signInStore: Instance<typeof SignInStore>;
}

export const RankingQuestionView = observer(
  ({
    surveyQuestionView,
    spacing,
    t,
    tokens,
    typography,
    border,
    cornerRadius,
    boxShadow,
    updateQuestionViewParams,
    isSurveyViewOptionDisplayTextSelected,
    allowSPoCToSelectGraphType,
    signInStore,
  }: RankingQuestionViewProps): ReactElement => {
    return (
      <QuestionView
        t={t}
        spacing={spacing}
        typography={typography}
        tokens={tokens}
        cornerRadius={cornerRadius}
        border={border}
        questionText={surveyQuestionView.question}
        sampleBreakdown={surveyQuestionView.sampleBreakdown}
        total={surveyQuestionView.sampleBreakdown.total}
        selectedGraph={
          QuestionTypeGraphs[surveyQuestionView.updatedRankingGraphType]
        }
        surveyQuestionViewType={
          SurveyQuestionViewStoreNames.RANKING_QUESTION_MODEL
        }
        updateSelectedGraphType={surveyQuestionView.updateSelectedGraphType}
        data={surveyQuestionView.rankingResults.map(
          (rankingResult): DataPropsForRanking => {
            return {
              option: isSurveyViewOptionDisplayTextSelected
                ? rankingResult.answer
                : rankingResult.code,
              count: rankingResult.count.map((count) => count),
              id: rankingResult.code,
            };
          },
        )}
        buttonProps={getButtonProps(
          updateQuestionViewParams,
          surveyQuestionView.surveyQuestionViewId,
          surveyQuestionView.questionViewGraphType,
          surveyQuestionView.isGraphSelectionUpdated,
          surveyQuestionView.updateSelectedGraphTypeWithUpdatedGraph,
        )}
        boxShadow={boxShadow}
        isChildQuestion={updateQuestionViewParams === undefined}
        isSurveyViewOptionDisplayTextSelected={
          isSurveyViewOptionDisplayTextSelected
        }
        allowSPoCToSelectGraphType={allowSPoCToSelectGraphType}
        signInStore={signInStore}
      />
    );
  },
);
